import * as React from "react"
import { cn } from "@/lib/utils"
import { Tabs, TabsList, TabsContent } from "@/components/ui/tabs"

const COLS: Record<number, string> = {
  1: "md:grid-cols-1",
  2: "md:grid-cols-2",
  3: "md:grid-cols-3",
  4: "md:grid-cols-4",
  5: "md:grid-cols-5",
  6: "md:grid-cols-6",
}

function DialogTabs({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof Tabs>) {
  return (
    <Tabs
      className={cn("flex-1 flex flex-col min-h-0 -mx-6", className)}
      {...props}
    />
  )
}

function DialogTabsList({
  className,
  columns = 2,
  ...props
}: React.ComponentPropsWithoutRef<typeof TabsList> & { columns?: number }) {
  return (
    <TabsList
      className={cn(
        "flex w-full pl-6 pr-6 rounded-none h-12 border-b [&>*]:flex-auto md:grid md:[&>*]:flex-none",
        COLS[columns] ?? "md:grid-cols-2",
        className,
      )}
      {...props}
    />
  )
}

function DialogTabsContent({
  className,
  scrollable = false,
  ...props
}: React.ComponentPropsWithoutRef<typeof TabsContent> & {
  scrollable?: boolean
}) {
  return (
    <TabsContent
      className={cn(
        "flex-1 mt-0 px-6",
        scrollable ? "overflow-y-auto" : "overflow-hidden",
        className,
      )}
      {...props}
    />
  )
}

export { DialogTabs, DialogTabsList, DialogTabsContent }
export { TabsTrigger as DialogTabsTrigger } from "@/components/ui/tabs"
